// extracted by mini-css-extract-plugin
export default {"container":"AboutMe_container__CDHmG","Image":"AboutMe_Image__5C+r2","swing-in":"AboutMe_swing-in__Z7jdw"};